import { MARKDOWN_BOLD_REGEX } from './constants';

// Tool callback utilities
const formatToolArguments = ({ tool }) => {
    if (!tool?.arguments) return '';

    const args = typeof tool.arguments === 'string' ? JSON.parse(tool.arguments) : tool.arguments;
    const formattedArgs = Object.entries(args).map(([key, value]) => `**${key}**: ${value}`);

    if (formattedArgs.length <= 1) return formattedArgs[0] ?? '';

    const lastArg = formattedArgs.pop();
    return `${formattedArgs.join(', ')} & ${lastArg}`;
};

export const createToolInitPhrase = ({ t, tool }) => {
    const args = formatToolArguments({ tool });
    const phrase = args
        ? t('label_copilot_tool_initializing_with_args', [tool?.name, args])
        : t('label_copilot_tool_initializing', [tool?.name]);

    return { phrase };
};

export const createToolDonePhrase = ({ t, tool }) => {
    return { phrase: t('label_copilot_tool_finishing', [tool?.name]) };
};

export const processLiveMarkdown = (text) => {
    return text.replace(MARKDOWN_BOLD_REGEX, '<b>$1</b>');
};

export const processStaticMarkdown = (textBox) => {
    if (!textBox) return;

    const htmlText = textBox.innerHTML;
    const newText = htmlText.replace(MARKDOWN_BOLD_REGEX, '<b>$1</b>');
    textBox.innerHTML = newText;
};
